// constants.js
export const MEMBERSTACK_PUBLIC_KEYS = {
    dev: "pk_sb_b1144ce3bdab57cbde46",
    prod: "pk_ddd43857fbc127c46714"
  };
  